import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const generatePDF = async () => {
    const input = document.getElementById('pdf-content');
    const canvas = await html2canvas(input, {
      backgroundColor: '#ffffff', 
      scale: 2, 
    });
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4'); // Create a new PDF document in portrait mode, A4 size
  
  
    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297; // A4 height in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;
  
    // Add the image to the PDF
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  
    // Add new pages if the content is longer than one page
    while (heightLeft >= 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }
  
    pdf.save('download.pdf');
  };

export default generatePDF;